'use strict'
import * as self from './date.js'

export const MIN_DATE_TIME = '1900-01-01 00:00:00.000'
export const MAX_DATE_TIME = '2099-12-31 23:00:00.000'

export const DISPLAY_DATE_TIME = 'DD.MM.YYYY HH:mm:ss'
export const DISPLAY_DATE_HOUR = 'DD.MM.YYYY HH:mm'
export const DISPLAY_DATE = 'DD.MM.YYYY'
export const DISPLAY_DATE_SHORT = 'DD.MM.YY'
export const DISPLAY_TIME = 'HH:mm:ss'
export const DISPLAY_HOUR = 'HH:mm'
export const MYSQL_DATETIME = 'YYYY-MM-DD HH:mm:ss'
export const MYSQL_DATE = 'YYYY-MM-DD'
export const MYSQL_TIME = 'HH:mm:ss'
export const FORM_DATE = 'YYYY-MM-DDTHH:mm'
export const FORM_DATE_WITHOUT_TIME = 'YYYY-MM-DD'

export const MONTH_START_OF_YEAR_HYDROLOGICAL = 10 // octobre

export default self
